// extracted by mini-css-extract-plugin
module.exports = {"root":"Info_root__2uopU","title":"Info_title__29Gsf","links":"Info_links__2OlRa","link":"Info_link__2_lF3","logo":"Info_logo__47SXr"};